export default class AccountApi {
  constructor(client) {
    this.client = client;
  }

  async getAccount() {
    return this.client.request('/api/account', { method: 'GET' });
  }

  async updateAccount({ address, phone_number }) {
    return this.client.request('/api/account', {
      method: 'PUT',
      body: JSON.stringify({ address, phone_number }),
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
